export default __webpack_public_path__ + "assets/c9f97f83c48512b10b249be16951a6fb.jpg";